import {
  getVariableValue,
  isAndroid,
  isVariable
} from "@tamagui/core";
const getElevation = (size, extras) => {
  if (!size)
    return;
  const { tokens } = extras;
  const token = tokens.size[size];
  const sizeNum = isVariable(token) ? +token.val : size;
  return getSizedElevation(sizeNum, extras);
};
const getSizedElevation = (val, { theme, tokens }) => {
  let num = 0;
  if (val === true) {
    const val2 = getVariableValue(tokens.size["true"]);
    if (typeof val2 === "number") {
      num = val2;
    } else {
      num = 10;
    }
  } else {
    num = +val;
  }
  const [height, shadowRadius] = [Math.round(num / 4 + 1), Math.round(num / 2 + 2)];
  const shadow = {
    shadowColor: theme.shadowColor,
    shadowRadius,
    shadowOffset: { height, width: 0 },
    ...isAndroid ? {
      elevationAndroid: 2 * height
    } : {}
  };
  return shadow;
};
export {
  getElevation,
  getSizedElevation
};
//# sourceMappingURL=getElevation.js.map
